define(['exports', 'react', 'lodash', '../../i18n', 'react-material-card', 'material-ui', './Candidate'], function (exports, _react, _lodash, _i18n, _reactMaterialCard, _materialUi, _Candidate) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _lodash2 = _interopRequireDefault(_lodash);

  var _i18n2 = _interopRequireDefault(_i18n);

  var _reactMaterialCard2 = _interopRequireDefault(_reactMaterialCard);

  var _Candidate2 = _interopRequireDefault(_Candidate);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SessionReportsView = function (_Component) {
    _inherits(SessionReportsView, _Component);

    function SessionReportsView() {
      _classCallCheck(this, SessionReportsView);

      return _possibleConstructorReturn(this, (SessionReportsView.__proto__ || Object.getPrototypeOf(SessionReportsView)).apply(this, arguments));
    }

    _createClass(SessionReportsView, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            _props$sessions = _props.sessions,
            _props$sessions$curre = _props$sessions.currentSession.candidatesReportSummary,
            candidatesReportSummary = _props$sessions$curre === undefined ? {} : _props$sessions$curre,
            selectedSkill = _props$sessions.selectedSkill,
            selectSkill = _props.selectSkill;


        if (_lodash2.default.isEmpty(selectedSkill) && !_lodash2.default.isEmpty(candidatesReportSummary)) {
          selectSkill(Object.keys(candidatesReportSummary)[0]);
        }
      }
    }, {
      key: 'getSelectedTabStyle',
      value: function getSelectedTabStyle(tab, selectedTab, index) {
        if (tab === selectedTab || index === 0 && !selectedTab) {
          return {
            'borderBottom': 'solid 4px ' + this.props.brandColor,
            'width': 'auto',
            'color': '#424242',
            'fontFamily': 'Nunito',
            // 'fontSize': '5rem',
            'fontWeight': '400',
            'letterSpacing': '0.08rem',
            // 'lineHeight': '27px',
            'paddingLeft': '0.5rem',
            'paddingRight': '0.5rem',
            'borderBottomLeftRadius': '0px!important',
            'borderBottomRightRadius': '0px!important'
          };
        } else {
          return {
            'borderBottom': 'none',
            'paddingBottom': '4px',
            // 'fontSize': '5rem',
            'letterSpacing': '0.08rem',
            'color': '#757575',
            'fontWeight': '300',
            'width': 'auto',
            'paddingLeft': '0.5rem',
            'paddingRight': '0.5rem',
            'borderBottomLeftRadius': '0px!important',
            'borderBottomRightRadius': '0px!important'
          };
        }
      }
    }, {
      key: 'handleTabSwitch',
      value: function handleTabSwitch(tab) {
        this.props.selectSkill(tab);
      }
    }, {
      key: 'getCandidateList',
      value: function getCandidateList() {
        var _props$sessions2 = this.props.sessions,
            _props$sessions2$curr = _props$sessions2.currentSession.candidatesReportSummary,
            candidatesReportSummary = _props$sessions2$curr === undefined ? {} : _props$sessions2$curr,
            selectedSkill = _props$sessions2.selectedSkill;

        var candidateList = [];

        var _candidateList = candidatesReportSummary[selectedSkill];

        if (!_lodash2.default.isEmpty(_candidateList)) {
          candidateList = _candidateList;
        } else if (!_lodash2.default.isEmpty(candidatesReportSummary)) {
          candidateList = candidatesReportSummary[Object.keys(candidatesReportSummary)[0]];
        }

        return candidateList || [];
      }
    }, {
      key: 'renderCandidateList',
      value: function renderCandidateList(candidateList) {
        var _props2 = this.props,
            currentSession = _props2.sessions.currentSession,
            getReportDownloadUrl = _props2.getReportDownloadUrl;


        return _react2.default.createElement(
          'div',
          { className: 'mt2' },
          candidateList.map(function (candidate, index) {
            return _react2.default.createElement(_Candidate2.default, { key: index, session: currentSession, candidate: candidate, getReportDownloadUrl: getReportDownloadUrl });
          })
        );
      }
    }, {
      key: 'renderHeader',
      value: function renderHeader() {
        var _props$sessions$curre2 = this.props.sessions.currentSession,
            name = _props$sessions$curre2.name,
            _scheduledAt = _props$sessions$curre2._scheduledAt,
            caratsEarned = _props$sessions$curre2.caratsEarned,
            attendedCandidatesCount = _props$sessions$curre2.attendedCandidatesCount,
            scheduledCandidatesCount = _props$sessions$curre2.scheduledCandidatesCount,
            _props$sessions$curre3 = _props$sessions$curre2.assessments,
            assessments = _props$sessions$curre3 === undefined ? [] : _props$sessions$curre3,
            _props$sessions$curre4 = _props$sessions$curre2.candidatesReportSummary,
            candidatesReportSummary = _props$sessions$curre4 === undefined ? {} : _props$sessions$curre4;


        var shouldRenderAssessmentName = assessments && assessments.length === 1 && (!_lodash2.default.isEmpty(candidatesReportSummary.notAttended) || !_lodash2.default.isEmpty(candidatesReportSummary.incomplete));

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'flex bold' },
            _react2.default.createElement(
              'div',
              { className: 'flex flex-auto' },
              _react2.default.createElement(
                'div',
                null,
                name && name.toUpperCase()
              ),
              _react2.default.createElement(
                'div',
                { className: 'ml2' },
                _scheduledAt
              )
            ),
            _react2.default.createElement(
              'div',
              { className: '' },
              attendedCandidatesCount + ' / ' + scheduledCandidatesCount + ' ' + _i18n2.default.t('dk-ui-lib.sessions.attended')
            )
          ),
          shouldRenderAssessmentName && _react2.default.createElement(
            'div',
            { className: 'mt2' },
            assessments[0].name.toUpperCase() + ' ' + _i18n2.default.t('dk-ui-lib.sessions.assessment')
          )
        );
      }
    }, {
      key: 'renderTabs',
      value: function renderTabs() {
        var _this2 = this;

        var _props$sessions3 = this.props.sessions,
            _props$sessions3$curr = _props$sessions3.currentSession.candidatesReportSummary,
            candidatesReportSummary = _props$sessions3$curr === undefined ? {} : _props$sessions3$curr,
            selectedSkill = _props$sessions3.selectedSkill;


        var tabs = Object.keys(candidatesReportSummary);

        return _react2.default.createElement(
          'div',
          { className: 'flex flex-wrap mt2' },
          _lodash2.default.map(tabs, function (tab, index) {
            return _react2.default.createElement(
              _materialUi.FlatButton,
              {
                style: _this2.getSelectedTabStyle(tab, selectedSkill, index),
                onTouchTap: function onTouchTap() {
                  return _this2.handleTabSwitch(tab);
                }
              },
              _react2.default.createElement(
                'div',
                { className: 'nunito-font' },
                _lodash2.default.upperCase(tab)
              )
            );
          })
        );
      }
    }, {
      key: 'render',
      value: function render() {

        var candidateList = this.getCandidateList();
        return _react2.default.createElement(
          _reactMaterialCard2.default,
          { level: 1, className: 'px4 py3' },
          this.renderHeader(),
          this.renderTabs(),
          candidateList.length ? this.renderCandidateList(candidateList) : null
        );
      }
    }]);

    return SessionReportsView;
  }(_react.Component);

  exports.default = SessionReportsView;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/session-reports/index.js
// module id = 1210
// module chunks = 0